function state() {
  return {
    insurerList: [],
  };
}

export default state;
